import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"

const initialState = { status: null, loading: false, data: [], total: 0, error: "", message: ""}



export const getVideoStatAction = createAsyncThunk(
    'all-video-stat',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/videoStat?page=${data?.page}&limit=${data?.pageSize}&s_date=${data?.startDate}&e_date=${data?.endDate}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const videoStatSlice = createSlice({
    name: 'all-video',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getVideoStatAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getVideoStatAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.total
            })
            builder.addCase(getVideoStatAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const videoStatReducer = videoStatSlice.reducer